import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import Configuration from 'views/admin/configuration/Configuration'

const Config = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <Configuration />
      </Route>
    </Switch>
  )
}

export default Config
